module.exports = __webpack_public_path__ + "static/media/Helvetica-LightOblique.09ed5351.ttf";